import { Component, LOCALE_ID, OnInit, inject } from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { CardSurveyComponent } from './pages/surveys/ui/card-survey/card-survey.component';
import { LandingComponent } from './pages/landing/landing.component';
import { MainFooterComponent } from './shared/main-footer/main-footer.component';
import { MainHeaderComponent } from './shared/main-header/main-header.component'
import { AppHeaderComponent } from './shared/app-header/app-header.component';
import { AuthFacade } from 'auth';
import { DefaultSessionService } from 'auth/src/lib/services/session.service';
import { LanguageService } from './core/services/language.service';
import { NotifyModule } from './shared/notify/notify.module';
import { environment } from 'src/environments/environment';
import { COUNTRY_URL_PARAM } from './contants';
import * as moment from 'moment';
import { ExpirationService } from 'auth/src/lib/services/expiration.service';
import { ConsumerIRepository } from 'auth/src/lib/data/consumer.repository';
import { TrackingService } from './core/services/tracking.service';


@Component({
  standalone: true,
  imports: [
    LandingComponent,
    CardSurveyComponent,
    MainHeaderComponent,
    AppHeaderComponent,
    MainFooterComponent,
    NotifyModule,
    RouterModule,
  ],
  providers: [],
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {

  readonly locale = inject(LOCALE_ID)
  readonly #router = inject(Router)
  readonly #petFacade = inject(AuthFacade)
  readonly #trackingService = inject(TrackingService)
  readonly #authFacade = inject(AuthFacade)
  readonly #languageService = inject(LanguageService)
  readonly #expirationService = inject(ExpirationService)
  readonly #consumerRepository = inject(ConsumerIRepository)
  readonly #sessionService = inject(DefaultSessionService)

  constructor() {

    /**
     * - Reset errors from auth store on route change
     */
    this.#router.events.subscribe((event: any) => {
      if (event instanceof NavigationEnd) {
        this.#authFacade.resetError()
        this.#petFacade.resetError()

        if (!this.#sessionService.getToken() && this.#sessionService.getUser()) {
          this.#authFacade.logout()
        }
       }
    })
  }

  ngOnInit() {

    // - LANGUAGE
    moment.locale(this.locale)

    // - EXPIRATION
    this.#consumerRepository.getConsumerDataExpiration().subscribe((expiration) => {
      this.#expirationService.setExpiration(expiration)

        // - LOAD USER
        // - Token is the single source of truth for the session identity (aligned with desktop populate())
        // - We no longer read the EXPLORE_USER cookie for the id: a stale cookie could reload the wrong user
        const token = this.#sessionService.getToken()
        if (token) {
          try {
            const payload = JSON.parse(atob(token.split('.')[1]))
            if (payload?.user_id) {
              this.#authFacade.reload(payload.user_id)
            } else {
              this.#authFacade.loadNoUser()
            }
          } catch {
            this.#authFacade.loadNoUser()
          }
        } else {
          this.#authFacade.loadNoUser()
        }
    })

    // - COUNTRY
    const urlCountryIso = new URLSearchParams(window.location.search).get(COUNTRY_URL_PARAM) || ''
    this.#languageService.init(urlCountryIso)

    // - UNREGISTER OLD SERVICE WORKER
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistrations().then((registrations) => {
        for (const registration of registrations) {
          registration.unregister()
        }
      })
    }
  }
}
